// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__2BxLz","tnc":"Terms_tnc__2Epm9","alignCenter":"Terms_alignCenter__2I-pE","alignJustify":"Terms_alignJustify__1NC3p"};